var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIncome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#31A790"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8706_27104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 29H12C11.448 29 11 28.552 11 28V22C11 21.448 11.448 21 12 21H14C14.552 21 15 21.448 15 22V28C15 28.552 14.552 29 14 29Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 24.9991H23.333C23.766 24.9991 24.187 24.8591 24.533 24.5991L26.949 22.7871C27.552 22.3351 28.396 22.3951 28.929 22.9281C29.521 23.5201 29.521 24.4791 28.929 25.0701L26.856 27.1431C26.298 27.7011 25.586 28.0821 24.812 28.2371L21.882 28.8231C21.301 28.9391 20.702 28.9251 20.127 28.7811L17.477 28.1191C17.16 28.0391 16.835 27.9991 16.508 27.9991H15",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 25H22.485C23.322 25 24 24.322 24 23.485V23.182C24 22.487 23.527 21.881 22.853 21.713L20.561 21.14C20.188 21.047 19.806 21 19.422 21C18.495 21 17.588 21.274 16.817 21.789L15 23",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1688 13.1555C26.2771 14.2638 26.2771 16.0607 25.1688 17.169C24.0605 18.2773 22.2636 18.2773 21.1553 17.169C20.047 16.0607 20.047 14.2638 21.1553 13.1555C22.2636 12.0471 24.0605 12.0471 25.1688 13.1555Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.631 12.375C22.538 11.81 22.28 11.267 21.844 10.831C20.736 9.723 18.939 9.723 17.831 10.831C16.723 11.939 16.723 13.736 17.831 14.844C18.521 15.534 19.477 15.793 20.368 15.624",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8706_27104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncome);
export default __webpack_public_path__ + "static/media/income.31309ee23c6ec1c309f92700f5c0e502.svg";
export { ForwardRef as ReactComponent };